$ = jQuery.noConflict();

$(() => {

	$('.gerenciar-favorito').on('click', function(event){

    /**
     * Botão de favorito clicado e URL da request
     */
		var el = $(this);
		var url = $(this).data("url");

    /**
     * Post para URL de gerenciamento de vavoritos
     */
		$.post(url, function(data) {
  		if(data["sucesso"] == true) {
        if (data["acao"] == "remover") {
          /**
           * Se a ação for remover, substitui a classe "remover-favorito" por "adicionar-favorito",
           * substitui "remover" por "adicionar" na URL do span, e adiciona o parâmetro "false"
           */
          el.removeClass("remover-favorito");
          el.addClass("adicionar-favorito");

          el.data("url", url.replace("remover", "adicionar").replace("false/", ""));
        } else {
          /**
           * Se a ação for adicionar, substitui a classe "adicionar-favorito" por "remover-favorito",
           * substitui "adicionar" por "remover" na URL do span, e adiciona o parâmetro "false"
           */
          el.removeClass("adicionar-favorito");
          el.addClass("remover-favorito");

          el.data("url", url.replace("adicionar", "remover").concat("false/"));
        }
  		}
  	});


	});

});
